import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Define which bike models this material fits
 * @primary Compatible bike models list
 * @persona paola-admin-belora
 */
export const Route = createFileRoute(
  "/app/c/$customerSlug/materials/$id/bike-models",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
